import React from "react";
import { X } from "lucide-react";

export default function ModalCard({
  title,
  children,
  onClose,                 // optional
  onPrimary,
  primaryText = "Continue",
  dismissible = true,      // if false: no X, no backdrop click
  accentBorder = "#65DEF6" // cyan border from the mock
}) {
  const stop = (e) => e.stopPropagation();

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center"
      style={{ backgroundColor: "rgba(25,25,25,0.70)" }}  // overlay #191919 @ ~70%
      onClick={dismissible ? onClose : undefined}
    >
      <div
        onClick={stop}
        className="relative flex flex-col justify-between"
        style={{
          width: 864,
          height: 286,
          borderRadius: 16,
          // 1.5px cyan border + subtle gray base like the mock
          boxShadow:
            "0px 5px 35px rgba(0,0,0,0.55), inset 0 0 0 1.5px " + accentBorder,
          backgroundColor: "#292929",
          padding: 24,
        }}
      >
        {dismissible && (
          <button
            aria-label="Close"
            onClick={onClose}
            // small lime X like the mock; positioned inside the card
            className="absolute -right-3 -top-3 grid place-items-center rounded-full"
            style={{
              width: 28,
              height: 28,
              background: "#232323",
              border: "1px solid #3a3a3a",
              color: "#CBDF52",
            }}
          >
            <X size={16} strokeWidth={3} />
          </button>
        )}

        {/* Title */}
        <h3
          style={{
            fontFamily: "Montserrat",
            fontWeight: 700,
            fontSize: 36,
            lineHeight: "120%",
            letterSpacing: "-0.03em",
            color: "#FFFFFF",
            textAlign: "center",
            marginTop: 6,        // visually matches the comp
            marginBottom: 10,
          }}
        >
          {title}
        </h3>

        {/* Body */}
        <div
          style={{
            fontFamily: "Montserrat",
            fontWeight: 400,
            fontSize: 20,
            lineHeight: "130%",
            color: "#E9E9E9",
            textAlign: "center",
            margin: "0 auto",
            maxWidth: 748, // body text width from the spec
          }}
        >
          {children}
        </div>

        {/* CTA */}
        <div className="flex justify-center" style={{ marginTop: 18 }}>
          <button
            onClick={onPrimary}
            className="font-semibold"
            style={{
              minWidth: 220,
              height: 44,
              borderRadius: 8,
              background: "#CBDF52",
              color: "#000000",
              boxShadow: "0 0 0 1px rgba(0,0,0,0.15) inset",
            }}
          >
            {primaryText}
          </button>
        </div>
      </div>
    </div>
  );
}
